var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.137 0.0214844H24.0192C21.7092 0.0569524 19.5406 0.97912 17.9142 2.62247C17.3602 3.17813 16.8888 3.79291 16.4999 4.45498C16.1109 3.79291 15.6395 3.17813 15.0856 2.62247C13.4702 0.984703 11.2772 0.0503918 8.98058 0.0214844H8.86272C4.07772 0.0214844 0.0234375 4.19488 0.0234375 9.14858C0.0234375 21.0067 15.2859 29.4836 15.9342 29.8382C16.1109 29.9328 16.3113 29.9801 16.4999 29.9801C16.6884 29.9801 16.8888 29.9328 17.0656 29.8382C17.7138 29.4836 32.9763 21.0067 32.9763 9.14858C32.9763 4.19488 28.922 0.0214844 24.137 0.0214844Z",
    fill: "#FC7336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_1528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavActiveIcon);
export default __webpack_public_path__ + "static/media/fav_active_icon.a4d30ad777b2d3c0035a5be4bb33f05f.svg";
export { ForwardRef as ReactComponent };